// extracted by mini-css-extract-plugin
export default {"base":"CheckBox_base__Lq0UJ"};